export default "__VITE_ASSET__CdHZmB4x__"